import { useRef, useState } from 'react'
import { HideLoder, ShowLoder } from '../../../JS/Common';
import AlertsComp from '../../../Components/AlertsComp';
import { ValidateFile } from '../../../Components/Validations';
import { log } from '../../../JS/Logger';
import { ApiCmnHeadersPostCall } from '../../../JS/Connector';
import { downloadSampleCSV } from '../../../Helpers/ImpExpHelper';
import useConfig from '../../../Hooks/useConfig';

export default function ImportSchoolProfile() {
    const ServiceProfileRef = useRef();
    const { organization } = useConfig();
    const [loading, setLoading] = useState(false);
    const [NewAlerts, setNewAlerts] = useState("");
    const [fileName, setFileName] = useState({
        users: '',
        error: ''
    });
    function ShowFileName() {
        const fileInput = ServiceProfileRef.current;
        const files = fileInput.files[0];
        if (!files) return;
        const filename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setFileName({ ...fileName, error: validationMsg, users: '' });
            fileInput.value = "";
            return;
        }
        setFileName({ ...fileName, error: '', users: filename });
    }
    async function ImportServiceProfileCSV(e) {
        setLoading(true)
        e.preventDefault();
        const fileInput = ServiceProfileRef.current;
        const files = fileInput.files[0];
        if (!files) {
            setLoading(false);
            setFileName({ ...fileName, error: "First, import the CSV file.", users: "" });
            return;
        }
        const filename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setLoading(false);
            setFileName({ ...fileName, error: validationMsg, users: "" });
            fileInput.value = "";
            return;
        }
        setFileName({ ...fileName, error: "", users: filename });

        var formdata = new FormData();
        formdata.append("file", files);

        try {
            const response = await ApiCmnHeadersPostCall(`/schools/profile/import`, formdata);
            const result = response;

            setLoading(false);

            if (result == "success") {
                setNewAlerts(<AlertsComp show={true} variant="success" msg={'CSV imported Successfully'} />);
                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                    setFileName({ ...fileName, users: '' })
                    fileInput.value = "";
                }, 1500);
            } else {
                const responseRs = JSON.parse(result);
                setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.error} />);
                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                }, 2000);
            }
            fileInput.value = "";
            setFileName({ ...fileName, users: '' });
        } catch (error) {
            log.error('error', error);
            fileInput.value = "";
            setFileName({ ...fileName, users: '' });
        }

    }
    return (
        <div>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Import Service Profile</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    To ensure that service profile are entered properly with data accuracy, please download our CSV template file and ensure your columns match the template before you import your service profile into the system.
                </p>

                <div className="row pt-1">
                    <div className="col-12">
                        <label className="pb-3 text-justify" style={{ fontSize: "13px" }}>
                            <a onClick={() => downloadSampleCSV('schoolProfilePricing', `${organization}ProfilePricing`)}
                                style={{ color: "#04ADFD", fontWeight: "600" }} className='cursor-pointer'>
                                CLICK HERE
                            </a> {" "}
                            to download the template CSV file for service profile. Please use this as a template and prepare your CSV file accordingly. Once your file is ready, use button below to browse file from your computer and click on upload button to import all data into your account.
                        </label>
                        <div className='col-12 pb-4'>
                            In the CSV import, you can import multi-select values by separating them with commas. For example, to import multiple devices into a district, enter values like Acer, HP, Lenovo.

                            To import a single-select value, simply enter the specific value. For example, for the "Route Frequency" field, you would enter Bi-Weekly.
                        </div>
                        <div className="col-12">
                            <form onSubmit={(e) => ImportServiceProfileCSV(e)}>
                                <input type="file" ref={ServiceProfileRef} name="student_file" id="StudentUploadFile" accept='.csv' onChange={(e) => ShowFileName()} />
                                <label className='ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="StudentUploadFile"> Import Service Profile
                                    <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                                </label>
                                {fileName.users != '' ?
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' style={{ backgroundColor: 'var(--primary-color)', color: '#fff' }} />
                                    :
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' />
                                }
                                <br />
                                <div id="ImportInventoryStudentText" style={{ fontWeight: "600", color: 'green' }}>{fileName.users}</div>
                                {fileName.error?.trim() != "" && <label className='redText'>{fileName.error}</label>}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
